/**
 * Unit of measure ("Jm.") as it should appear next to a POCK quantity.
 *
 * The order form does not validate the "Jm." column, so users occasionally type
 * a number there — usually "1", meaning the quantity rather than the unit.
 * Rendering that on a POCK line produces "3 1" and reads like a typo, so a
 * purely numeric unit is treated as "no unit given" and dropped. Everything
 * else is passed through untouched: real units ("szt.", "m2", "mb", "100 m")
 * are never numbers on their own.
 */
const NUMERIC_ONLY = /^[+-]?\d+(?:[.,]\d+)?$/;

export function displayUnit(unit: string | null | undefined): string {
  const trimmed = (unit ?? "").trim();
  return NUMERIC_ONLY.test(trimmed) ? "" : trimmed;
}
